import * as React from 'react';
import { createStyles, WithStyles, withStyles, } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Link from 'src/modules/shared/components/Link';
import HttpService from '../../core/services/HttpService';
import SnackbarService from '../../core/services/SnackbarService';
import { Typography } from '@material-ui/core';
import BreadCrumb from 'src/modules/shared/components/BreadCrumb';
import Loading from '../../shared/components/loading/Loading';
import SubscriptionToolbar from './SubscriptionToolbar';
import { IInvoice, ISubscription } from '../models/Interfaces';
import { Payment, Description } from '@material-ui/icons';

const httpService = HttpService.Instance;
const snackbarService = SnackbarService.Instance;

const styles = createStyles({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    minWidth: 650,
  },
});

interface IState {
  invoices: IInvoice[];
  subscriptions: ISubscription[];
  loading: boolean;
}

interface IProps extends WithStyles<typeof styles> {
  match: any;
}

class Verifications extends React.Component<IProps> {
  public state: IState = {
    invoices: [],
    subscriptions: [],
    loading: true,
  };

  public async componentDidMount() {
    this.loadInvoices();
    this.loadSubscriptions();
  }

  public loadInvoices = async () => {
    const response = await httpService.get(
      process.env.REACT_APP_API_URL + 'billing/invoices',
      { disableErrorMessageing: true }
    );

    if (response.ok) {
      this.setState({ invoices: await response.json() });
    } else {
      snackbarService.showSnackbar('error', 'Could not load invoices, please contact support.');
    }

    this.setState({ loading: false });
  };

  public loadSubscriptions = async () => {
    const response = await httpService.get(
      process.env.REACT_APP_API_URL + 'billing/subscriptions',
      { disableErrorMessageing: true }
    );

    if (response.ok) {
      this.setState({ subscriptions: await response.json() });
    } else {
      snackbarService.showSnackbar('error', 'Could not load subscriptions, please contact support.');
    }
  };

  public render() {
    const { classes } = this.props;
    const { invoices, subscriptions, loading } = this.state;

    return (
      <div>
        <Typography variant="title">Invoices</Typography>
        <Typography color="textSecondary" gutterBottom={true}>
          <BreadCrumb value="Console" to="/" />
          Billing
        </Typography>
        <br />
        {loading ? (
          <Loading />
        ) : (
            <Paper className={classes.root}>
              <SubscriptionToolbar subscriptions={subscriptions} />
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Invoice Nr.</TableCell>
                    <TableCell>Due Date</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Pay</TableCell>
                    <TableCell>Download</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {invoices.map(invoice => (
                    <TableRow key={invoice.invoiceNumber}>
                      <TableCell component="th" scope="row">
                        <Link url={invoice.invoicePdfUrl} download>
                          {invoice.invoiceNumber}
                        </Link>
                      </TableCell>
                      <TableCell>{new Date(invoice.dueDate).toLocaleDateString()}</TableCell>
                      <TableCell>{new Date(invoice.date).toLocaleDateString()}</TableCell>
                      <TableCell>€ {invoice.amount}</TableCell>
                      <TableCell>{invoice.status}</TableCell>
                      <TableCell>
                        {invoice.invoicePdfUrl &&
                          <Link url={invoice.invoicePdfUrl.replace("/pdf", "")}>
                            <Payment />
                          </Link>
                        }
                      </TableCell>
                      <TableCell>
                      {invoice.invoicePdfUrl &&
                        <Link url={invoice.invoicePdfUrl}>
                          <Description />
                        </Link>
                      }
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          )}
      </div>
    );
  }
}

export default withStyles(styles)(Verifications);



// WEBPACK FOOTER //
// ./src/modules/billing/pages/Billing.tsx